import { render, staticRenderFns } from "./messageDoc.vue?vue&type=template&id=740775c2&scoped=true&"
import script from "./messageDoc.vue?vue&type=script&lang=js&"
export * from "./messageDoc.vue?vue&type=script&lang=js&"
import style0 from "./messageDoc.vue?vue&type=style&index=0&id=740775c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740775c2",
  null
  
)

export default component.exports